import { gate } from 'hub-http/gates';
import { useGate } from './useGate';
const CUSTOMER_AGENT_DISCOVERABILITY_GATE = gate('HelpDesk:CustomerAgentDiscoverability');

/**
 * Hook to check if the user is ungated for customer agent discoverability.
 *
 * @returns {boolean} Whether the user is ungated for HelpDesk:CustomerAgentDiscoverability
 */
export const useIsUngatedForCustomerAgentDiscoverability = () => {
  return useGate(CUSTOMER_AGENT_DISCOVERABILITY_GATE);
};